import { render, staticRenderFns } from "./TgDocument.vue?vue&type=template&id=31860308"
import script from "./TgDocument.vue?vue&type=script&lang=js"
export * from "./TgDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports